import { Stack } from "@mui/material";
import {
  ContainedButtonWithForwardArrow,
  PrimaryFormDateOfBirth,
} from "react-common-ui-library";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  CONFIRM_PASSWORD_FIELD_NAME,
  PASSWORD_FIELD_NAME,
  USER_NAME_FIELD_NAME,
} from "../../../Constants/AccountSetupConstants";
import {
  ACCOUNT_CREATION_FLOW,
  ACCOUNT_CREATION_ROUTE,
  BUTTON,
  EMAIL_LANGUAGE,
  MODE_ALL,
  NEXT_STEP,
  PROVIDER_ACCOUNT_CREATION,
  PROVIDER_REVIEW_INFO,
} from "../../../Constants/CommonConstants";
import {
  DATE_OF_BIRTH,
  PROF_LICENSE_NO,
  PROF_LICENSE_NO_RADIO_FIELD,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { saveProviderAccountData } from "../../../Features/ProviderAccountCreationSlice";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { StyledDateOfBirthBox } from "../../../Styles/ProviderAndCertifierAccountCreation/ProviderAccountCreationStyles";
import { ProfLicenseNumberForm } from "./ProfLicenseNumberForm";
import ProviderAccountSetupForm from "./ProviderAccountSetupForm";
import EmailLanguage from "../../Common/EmailLanguage";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";
import { useEffect } from "react";

/**
 * @description Displays the Provider Account Creation Form components
 * @returns {ReactNode} Renders the provider account creation form components namely Professional Lisence Number,Date of Birth, Account Setup form component along with submit button
 */
export const AccountCreationForm = () => {
  const {
    username,
    password,
    profLicenseNo,
    dob,
    emailLanguage,
    emailLangCd,
    hasProfLicenseNo,
  } = useSelector((state) => manageProviderAccountCreationSelector(state));

  const { englishEmailLanguage, spanishEmailLanguage } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const intl = useIntl();

  const methods = useForm({
    mode: MODE_ALL,
    criteriaMode: MODE_ALL,
    defaultValues: {
      [USER_NAME_FIELD_NAME]: username,
      [PASSWORD_FIELD_NAME]: password,
      [CONFIRM_PASSWORD_FIELD_NAME]: password,
      [PROF_LICENSE_NO]: profLicenseNo,
      [DATE_OF_BIRTH]: dob,
      [PROF_LICENSE_NO_RADIO_FIELD]: hasProfLicenseNo,
    },
  });

  const { setValue } = methods;

  useEffect(() => {
    if (emailLanguage) {
      setValue(EMAIL_LANGUAGE, emailLanguage);
    } else if (emailLangCd === 113) {
      setValue(EMAIL_LANGUAGE, spanishEmailLanguage);
    } else {
      setValue(EMAIL_LANGUAGE, englishEmailLanguage);
    }
  }, [
    setValue,
    emailLanguage,
    emailLangCd,
    spanishEmailLanguage,
    englishEmailLanguage,
  ]);

  const handleNextStep = (data) => {
    sessionStorage.setItem(ACCOUNT_CREATION_FLOW, PROVIDER_ACCOUNT_CREATION);
    dispatch(saveProviderAccountData(data));
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${PROVIDER_REVIEW_INFO}`);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleNextStep)}>
        <Stack spacing={5}>
          <EmailLanguage />
          <ProfLicenseNumberForm />
          <Stack spacing={8}>
            <StyledDateOfBirthBox>
              <PrimaryFormDateOfBirth />
            </StyledDateOfBirthBox>
            <ProviderAccountSetupForm />
            <ContainedButtonWithForwardArrow
              id={NEXT_STEP}
              type={BUTTON}
              onClick={methods?.handleSubmit(handleNextStep)}
            >
              {intl.formatMessage({ id: NEXT_STEP })}
            </ContainedButtonWithForwardArrow>
          </Stack>
        </Stack>
      </form>
    </FormProvider>
  );
};
